import { render, staticRenderFns } from "./GameSpeedDisplay.vue?vue&type=template&id=4da9fdc5&scoped=true"
import script from "./GameSpeedDisplay.vue?vue&type=script&lang=js"
export * from "./GameSpeedDisplay.vue?vue&type=script&lang=js"
import style0 from "./GameSpeedDisplay.vue?vue&type=style&index=0&id=4da9fdc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da9fdc5",
  null
  
)

export default component.exports